var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mail-templates-editor',{model:{value:(_vm.mail_template),callback:function ($$v) {_vm.mail_template=$$v},expression:"mail_template"}})
}
var staticRenderFns = []

export { render, staticRenderFns }